import React, { HTMLAttributes } from 'react';
import { IconType } from 'react-icons';

export enum InfoCardVariant {
    IMAGE,
    NO_IMAGE
}

interface InfoCardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
    icon: IconType,
    title?: string | React.ReactNode,
    description?: string | React.ReactNode
    actions?: React.ReactNode,
    image?: React.ReactNode
    bodyClassName?: string,
    preTitle?: string | React.ReactNode,
    variant?: InfoCardVariant
    loading?: boolean
}

const InfoCard = ({
    children,
    title,
    image,
    description,
    icon: Icon,
    className,
    bodyClassName,
    actions,
    preTitle,
    variant = InfoCardVariant.IMAGE,
    loading = false,
    ...rest
}: InfoCardProps) => {
    return (
        <article
            className={`card no-prose transition-shadow duration-200 hover:shadow-lg rounded-2xl border border-base-200 ${variant === InfoCardVariant.IMAGE ? 'bg-base-100' : 'bg-base-200'} ${loading ? 'skeleton bg-base-200' : ''} ${className ?? ''}`}
            {...rest}
        >
            {image}
            <div className={`card-body grow flex flex-col sm:flex-row gap-4 ${variant === InfoCardVariant.IMAGE ? '' : 'p-6'} ${bodyClassName ?? ''}`}>
                {Icon && (
                    <div className="flex-shrink-0 flex items-center justify-center w-14 h-14 rounded-full bg-secondary text-primary text-3xl mb-2 sm:mb-0 shadow-sm">
                        <Icon className="w-6 h-6" />
                    </div>
                )}
                <div className={`h-full w-full flex flex-col justify-center`}>
                    {preTitle && <div className="text-xs text-base-content/60 mb-1">{preTitle}</div>}
                    {title && <header className="card-title mb-2 text-xl font-bold text-base-content">{title}</header>}
                    {children}
                    {description && <p className='not-prose grow-0 text-base-content/80 mb-2'>{description}</p>}
                    {actions && <div className='card-actions mt-2'>{actions}</div>}
                </div>
            </div>
        </article>
    );
};

export default InfoCard;
